import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loadingEmail: false,
  sendEmailSuccess: false,
  errorEmail: null,
}

const slice = createSlice({
  name: 'sendEmail',
  initialState: initialState,
  reducers: {
    sendEmailAction: (state, action) => {
      state.loadingEmail = true
      state.errorEmail = null
    },
    sendEmailSuccessAction:(state)=>{
      state.loadingEmail = false
      state.sendEmailSuccess = true
      state.errorEmail = null
    },
    sendEmailErrorAction: (state, action) => {
      state.loadingEmail = false
      state.sendEmailSuccess = false
      state.errorEmail = action.payload
    },
    sendEmailResetState: () => initialState,
  },
});

export const {
  sendEmailAction,
  sendEmailSuccessAction,
  sendEmailErrorAction,
  sendEmailResetState
} = slice.actions

export default slice.reducer
